import { h } from 'vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(UiComponentWrapper, { class: 'g2-grid' }, () => [
    h(UiComponentContainer, {}, () => [
      h(
        UiComponentHeading,
        { level: 2 },
        () => [props.record.title],
      ),
      h(UiComponentParagraph, {}, () => [props.record.text]),
      h(UiComponentWrapper, { class: 'inner' }, () => [
        h(UiComponentWrapper, { class: 'content' }, () => [
          props.record.testimonial.avatar
          && props.record.testimonial.logo
          && props.record.testimonial.quote
          && h(UiComponentWrapper, { class: 'testimonial' }, () => [
            h(UiComponentParagraph, { class: 'quote' }, () => [
                `«${props.record.testimonial.quote}»`,
            ]),
            h(UiComponentWrapper, { class: 'footer' }, () => [
              h(UiComponentWrapper, { class: 'author' }, () => [
                h(UiComponentImage, {
                  alt: props.record.testimonial.avatar.alt,
                  class: 'avatar',
                  expectedSize: 32,
                  height: props.record.testimonial.avatar.height,
                  source: props.record.testimonial.avatar.url,
                  width: props.record.testimonial.avatar.width,
                }),
                h(UiComponentWrapper, { class: 'metadata' }, () => [
                  h(UiComponentParagraph, { class: 'name' }, () => [
                      `${props.record.testimonial.author}, `,
                  ]),
                  h(UiComponentParagraph, { class: 'position' }, () => [
                    props.record.testimonial.position,
                  ]),
                ]),
              ]),
              h(UiComponentImage, {
                alt: props.record.testimonial.logo.alt,
                class: 'logo',
                contains: true,
                expectedSize: 98,
                height: props.record.testimonial.logo.height,
                source: props.record.testimonial.logo.url,
                width: props.record.testimonial.logo.width,
              }),
            ]),
          ]),
          h(
            UiComponentWrapper,
            { class: 'medals' },
            () => [
              ...props.record.medals.map(({ medal }, index) => {
                return h(
                  UiComponentWrapper,
                  { class: 'medal' },
                  () => [
                    h(UiComponentImage, {
                      key: `${index}-${props.g2GridImageWidth}`,
                      alt: medal.alt,
                      expectedSize: props.g2MedalImageWidth,
                      height: medal.height,
                      orientation: 'portrait',
                      source: medal.url,
                      width: medal.width,
                    }),
                  ],
                )
              }),
            ],
          ),
        ]),
        h(UiComponentWrapper, { class: 'image' }, () => [
          h(UiComponentImage, {
            key: props.g2GridImageWidth,
            alt: props.record.image.alt,
            expectedSize: props.g2GridImageWidth,
            height: props.record.image.height,
            source: props.record.image.url,
            width: props.record.image.width,
          }),
        ]),
      ]),
    ]),
  ])
}

Functional.props = {
  g2GridImageWidth: {
    required: false,
    type: Number,
  },
  g2MedalImageWidth: {
    required: false,
    type: Number,
  },
  record: {
    required: true,
    type: Object,
  },
}

export default Functional
